module.exports = __webpack_public_path__ + "static/media/103-shield.22e398d7.svg";